import React, { useState } from 'react';
import { Search } from 'react-feather';

const Searchbar = () => {
  const SeacrhResposive = () => {
    document.querySelector('.search-full').classList.add('open');
  };

  return (
    <li>
      <span className='header-search'>
        <Search onClick={() => SeacrhResposive()} />
      </span>
    </li>
  );
};

export default Searchbar;
